/** 标记发布接口返回的业务提示，供表单展示；网络及本地异常仍使用通用失败文案。 */
export class PublishBusinessError extends Error {}
